import { ENTITIES } from '@components/CRM/Notifications/constants';
import { createAction } from '@reduxjs/toolkit';
import { ValueOf } from '@utils/tsUtils';

const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';
const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS';
const GO_TO_NOTIFICATION_ENTITY = 'GO_TO_NOTIFICATION_ENTITY';

export const WS_ADD_NOTIFICATION_IN_LIST = 'WS_ADD_NOTIFICATION_IN_LIST';

export const fetchNotificationsAction = createAction(FETCH_NOTIFICATIONS);
export const readNotificationsAction = createAction<{
  id?: string;
  markAll?: boolean;
  onSuccess?: () => void;
}>(READ_NOTIFICATIONS);
export const deleteNotificationsAction = createAction<{
  id?: string;
  deleteAll?: boolean;
  onSuccess: () => void;
}>(DELETE_NOTIFICATIONS);
export const goToNotificationEntityAction = createAction<{
  entityType: ValueOf<typeof ENTITIES>;
  id: string;
}>(GO_TO_NOTIFICATION_ENTITY);

export type ReadNotificationsPayload = Parameters<
  typeof readNotificationsAction
>[0];
export type DeleteNotificationsPayload = Parameters<
  typeof deleteNotificationsAction
>[0];
export type GoToNotificationPayload = Parameters<
  typeof goToNotificationEntityAction
>[0];
